import state from './modulePurchaseOrderStatusState.js'
import mutations from './modulePurchaseOrderStatusMutations.js'
import actions from './modulePurchaseOrderStatusActions.js'
import getters from './modulePurchaseOrderStatusGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
